import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/isr-calculos-anuales-empleados';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Calculos Anuales ISR Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCalculosAnualesISREmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Calculo Anual ISR Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCalculoAnualISREmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Calculo Anual ISR Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCalculoAnualISREmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST URL Calculo Anual ISR
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postURLCalculoAnualISR = async (id) => {
  try {
    const response = await API.post(`nominas/isr-calculos-anuales-revisar-empleados/${id}`);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Calculo Anual ISR Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCalculoAnualISREmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCalculoAnualISREmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
